import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { confirmMsg, t } from '../../common/i18n/index.js';
import { DialogWrapper, buttonsForSubmitAndBack } from '../DialogWrapper/index.js';
import type { CommonError } from '../../common/types/errors.js';
import type { JSX, ReactNode } from 'react';

export interface ConfirmationDialogProps {
  body: string | JSX.Element;
  confirmButtonText?: string;
  disableConfirm?: boolean;
  errors?: CommonError[];
  header: string;
  hideClosingCross?: boolean;
  isLoading?: boolean;
  onCloseDialog: () => void;
  onConfirm: (onCloseDialog: () => void) => void;
  wide?: boolean;
  icon?: ReactNode;
}

export const ConfirmationDialog = ({
  body,
  confirmButtonText,
  disableConfirm,
  errors,
  header,
  hideClosingCross,
  isLoading,
  onCloseDialog,
  onConfirm,
  wide,
  icon,
}: ConfirmationDialogProps) => {
  return (
    <DialogWrapper
      buttons={buttonsForSubmitAndBack(
        onCloseDialog,
        () => onConfirm(onCloseDialog),
        undefined,
        undefined,
        confirmButtonText || t.QVYK(confirmMsg),
        disableConfirm,
        isLoading
      )}
      closeable={!hideClosingCross}
      header={header}
      onCloseDialog={onCloseDialog}
      size={wide ? 'l' : 'm'}
      icon={icon}
    >
      {body}
      {errors &&
        errors.map((error, i) => (
          <CL.Disclaimer
            className={dsClass.TEXT_M}
            icon={<CL.Icon icon="warning" />}
            key={i}
            text={error.message}
            visible
          />
        ))}
    </DialogWrapper>
  );
};
